// extracted by mini-css-extract-plugin
module.exports = {"prevButton":"style-module--prevButton--1fX1Z","prevArrow":"style-module--prevArrow--2Uo1e"};